import { SvgIcon, SvgIconProps } from "@mui/material";

export const EditIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12.458 1.40527C13.398 0.465241 14.9223 0.465263 15.8623 1.40527L16.5947 2.1377C17.5347 3.07774 17.5348 4.60196 16.5947 5.54199L5.76465 16.3711L0.742188 17.2568L1.62793 12.2344L12.458 1.40527Z"
        stroke="#707070"
        strokeWidth="1.4"
      />
    </SvgIcon>
  );
};

export const ServiceOverviewTitleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.2827 3.45258C11.5131 2.98564 11.6284 2.75218 11.7848 2.67758C11.9209 2.61268 12.0791 2.61268 12.2152 2.67758C12.3717 2.75218 12.4869 2.98564 12.7174 3.45258L14.9041 7.88255C14.9721 8.0204 15.0061 8.08933 15.0558 8.14284C15.0999 8.19023 15.1527 8.22862 15.2113 8.25589C15.2776 8.28669 15.3536 8.29781 15.5057 8.32004L20.397 9.03497C20.9121 9.11026 21.1696 9.1479 21.2888 9.2737C21.3925 9.38316 21.4412 9.53356 21.4215 9.68304C21.3988 9.85485 21.2124 10.0364 20.8395 10.3996L17.3014 13.8457C17.1912 13.9531 17.136 14.0068 17.1004 14.0707C17.0689 14.1273 17.0487 14.1895 17.0409 14.2538C17.0321 14.3264 17.0451 14.4023 17.0711 14.554L17.906 19.4214C17.994 19.9348 18.038 20.1914 17.9553 20.3438C17.8833 20.4763 17.7554 20.5693 17.6071 20.5967C17.4366 20.6283 17.2061 20.5071 16.7451 20.2647L12.3724 17.9651C12.2361 17.8935 12.168 17.8576 12.0962 17.8436C12.0327 17.8311 11.9673 17.8311 11.9038 17.8436C11.832 17.8576 11.7639 17.8935 11.6277 17.9651L7.25492 20.2647C6.79392 20.5071 6.56341 20.6283 6.39297 20.5967C6.24468 20.5693 6.11672 20.4763 6.04474 20.3438C5.962 20.1914 6.00603 19.9348 6.09407 19.4214L6.92889 14.554C6.95491 14.4023 6.96793 14.3264 6.95912 14.2538C6.95132 14.1895 6.93111 14.1273 6.89961 14.0707C6.86402 14.0068 6.80888 13.9531 6.69859 13.8457L3.16056 10.3996C2.78766 10.0364 2.60121 9.85485 2.57853 9.68304C2.55879 9.53356 2.60755 9.38316 2.71125 9.2737C2.83044 9.1479 3.08797 9.11026 3.60304 9.03497L8.49431 8.32004C8.64642 8.29781 8.72248 8.28669 8.78872 8.25589C8.84736 8.22862 8.90016 8.19023 8.94419 8.14284C8.99391 8.08933 9.02793 8.0204 9.09597 7.88255L11.2827 3.45258Z"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const GoServiceTitleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.252 12.459V19.2451H2.75195V12.459H21.252ZM21.252 7.62012V9.70996H2.75195V7.62012H21.252Z"
        stroke="#106048"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
};

export const OverallCardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const RatingCardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M11.6157 3.45258C11.8461 2.98564 11.9614 2.75218 12.1178 2.67758C12.254 2.61268 12.4121 2.61268 12.5482 2.67758C12.7047 2.75218 12.8199 2.98564 13.0504 3.45258L15.2371 7.88255C15.3051 8.0204 15.3391 8.08933 15.3889 8.14284C15.4329 8.19023 15.4857 8.22862 15.5443 8.25589C15.6106 8.28669 15.6866 8.29781 15.8387 8.32004L20.73 9.03497C21.2451 9.11026 21.5026 9.1479 21.6218 9.2737C21.7255 9.38316 21.7743 9.53356 21.7545 9.68304C21.7318 9.85485 21.5454 10.0364 21.1725 10.3996L17.6345 13.8457C17.5242 13.9531 17.469 14.0068 17.4334 14.0707C17.4019 14.1273 17.3817 14.1895 17.3739 14.2538C17.3651 14.3264 17.3781 14.4023 17.4042 14.554L18.239 19.4214C18.327 19.9348 18.371 20.1914 18.2883 20.3438C18.2163 20.4763 18.0884 20.5693 17.9401 20.5967C17.7696 20.6283 17.5391 20.5071 17.0781 20.2647L12.7054 17.9651C12.5691 17.8935 12.501 17.8576 12.4292 17.8436C12.3657 17.8311 12.3003 17.8311 12.2368 17.8436C12.165 17.8576 12.0969 17.8935 11.9607 17.9651L7.58793 20.2647C7.12692 20.5071 6.89642 20.6283 6.72598 20.5967C6.57769 20.5693 6.44973 20.4763 6.37775 20.3438C6.29501 20.1914 6.33903 19.9348 6.42708 19.4214L7.26189 14.554C7.28792 14.4023 7.30093 14.3264 7.29213 14.2538C7.28433 14.1895 7.26412 14.1273 7.23261 14.0707C7.19703 14.0068 7.14188 13.9531 7.03159 13.8457L3.49357 10.3996C3.12067 10.0364 2.93422 9.85485 2.91153 9.68304C2.89179 9.53356 2.94056 9.38316 3.04426 9.2737C3.16344 9.1479 3.42098 9.11026 3.93605 9.03497L8.82732 8.32004C8.97943 8.29781 9.05549 8.28669 9.12173 8.25589C9.18037 8.22862 9.23317 8.19023 9.27719 8.14284C9.32691 8.08933 9.36094 8.0204 9.42898 7.88255L11.6157 3.45258Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ReviewsCardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M8.66699 9.5H12.667M8.66699 13H15.667M12.667 21C17.6376 21 21.667 16.9706 21.667 12C21.667 7.02944 17.6376 3 12.667 3C7.69643 3 3.66699 7.02944 3.66699 12C3.66699 13.1971 3.90073 14.3397 4.32505 15.3845C4.40627 15.5845 4.44687 15.6845 4.46499 15.7653C4.48271 15.8443 4.48919 15.9028 4.4892 15.9839C4.48921 16.0667 4.47417 16.1569 4.4441 16.3374L3.85112 19.8952C3.78902 20.2678 3.75797 20.4541 3.81575 20.5888C3.86632 20.7067 3.96028 20.8007 4.07818 20.8512C4.21289 20.909 4.39917 20.878 4.77175 20.8159L8.32964 20.2229C8.51008 20.1928 8.6003 20.1778 8.68312 20.1778C8.76415 20.1778 8.82265 20.1843 8.90171 20.202C8.98253 20.2201 9.08252 20.2607 9.28248 20.3419C10.3273 20.7663 11.4698 21 12.667 21Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ButtonArrowRightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 12H20M20 12L14 6M20 12L14 18"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const SliderArrowRightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9775 13.5563H3.42383V10.4423H15.9775L11.1628 5.31522L13.2306 3.11328L21.5752 11.9993L13.2306 20.8853L11.1628 18.6833L15.9775 13.5563Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const SliderArrowLeftIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62155 10.5001H21.5002V13.5001H8.62155L13.5609 18.4395L11.4396 20.5608L2.87891 12.0001L11.4396 3.43945L13.5609 5.56077L8.62155 10.5001Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};
